export default [
    {
        key: "actions",
        label: "",
        thStyle: { width: "30px" }
    },
    {
        key: "pzn",
        label: "PZN",
        sortable: true,
        isNumberField: true,
        withoutComma: true,
        thStyle: { width: "14ch", "max-width": "70px" }
    },
    {
        key: "name",
        label: "Artikel",
        sortable: true,
        class: "article-name",
        thStyle: { "min-width": "60px" }
    },
    {
        key: "grossProfitPercent",
        label: "Ertrag (%)",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "changePercent",
        label: "Änd. (%)",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "60px" }
    },
    {
        key: "sellingPricePharmacy",
        label: "VK Apo",
        class: "lupus-success",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "60px" }
    },
    {
        key: "priceNew",
        sortable: true,
        label: "Preis neu",
        thStyle: { width: "92px" }
    },
    {
        key: "recommendedSellingPrice",
        label: "Empf. VK",
        class: "lupus-warning",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "minMarketPrice",
        label: "Min Markt",
        class: "lupus-info",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "maxMarketPrice",
        label: "Max Markt",
        class: "lupus-info",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "averageMarketPrice",
        label: "Durch Markt",
        class: "lupus-info",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "averageSellingCount",
        label: "Durch Anz. VK",
        class: "lupus-info",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "buyingPricePharmacy",
        label: "EK Apo",
        class: "lupus-success",
        sortable: true,
        isNumberField: true,
        thStyle: { width: "62px" }
    },
    {
        key: "sellingCountPharmacy",
        label: "Anz. VK Apo",
        class: "lupus-success",
        isNumberField: true,
        withoutComma: true,
        sortable: true,
        thStyle: { width: "62px" }
    },
    {
        key: "onStorage",
        sortable: true,
        label: "Lager",
        thStyle: { width: "68px" }
    }
];
